package one.healthium.med.presentation.navigation.home

import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.webhistory.WebNavigationOwner
import com.arkivanov.decompose.value.Value
import one.healthium.content.navigation.content.ContentComponent
import one.healthium.content.navigation.insights.InsightsComponent
import one.healthium.content.navigation.main.MainContentComponent
import one.healthium.content.navigation.shopping_list.ShoppingListComponent
import one.healthium.med.presentation.navigation.today.TodayComponent
import one.healthium.profile.navigation.ProfileMainComponent
import one.healthium.tasks.navigation.DailyTasksComponent
import one.healthium.today.ui.med.TodayEventDelegate
import one.primehealth.app.DeepLink

interface HomeComponent : WebNavigationOwner, TodayEventDelegate {
    val stack: Value<ChildStack<*, Child>>
    var isCompactMode: Boolean

    fun onTodayTabClicked()
    fun onDailyTasksTabClicked()
    fun onInsightsTabClicked()
    fun onMainContentTabClicked()
    suspend fun onChatTabClicked()
    fun onProfileTabClicked()
    fun onDeepLink(deepLink: DeepLink)

    sealed class Child {
        class TodayChild(val component: TodayComponent) : Child()
        class DailyTasksChild(val component: DailyTasksComponent) : Child()
        class InsightsChild(val component: InsightsComponent) : Child()
        class MainContentChild(val component: MainContentComponent) : Child()
        data object ChatChild : Child()
        class ProfileChild(val component: ProfileMainComponent) : Child()
        class Content(val component: ContentComponent) : Child()
        class ShoppingList(val component: ShoppingListComponent) : Child()
    }
}